import { Outlet } from 'react-router-dom';
import PageLayout from '../../shared/ui/layouts/PageLayout/PageLayout';
import { SegmentedControl } from '../../shared/ui';
import { PATHS } from '../../app/routes/paths';

const SETTINGS_TABS = [
  { label: 'Mail', value: 'mail', to: PATHS.settingsMail },
  { label: 'Push', value: 'push', to: PATHS.settingsPush },
];

export function SettingsPage() {
  return (
    <PageLayout pageTitle="Einstellungen">
      <SegmentedControl
        items={SETTINGS_TABS}
        ariaLabel="Einstellungen-Bereiche"
      />
      <Outlet />
    </PageLayout>
  );
}
